import { TextMapper } from "../prosemirror/TextMapper"
import { getText, getTextSerializersFromSchema } from '@tiptap/core'
import { EditorView } from '@tiptap/pm/view'

export const getRange = (view: EditorView, offset: number, length: number) => {
    const state = view.state
    const schema = state.schema
    const text = getText(state.doc, { textSerializers: { ...getTextSerializersFromSchema(schema) } })

    const textMapper = new TextMapper(state.doc, text, { schema: schema})
    return textMapper.getRange(offset, length)
}